var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("transition", { attrs: { name: "slide-fade" } }, [
    _vm.visible
      ? _c(
          "div",
          { staticClass: "file-upload" },
          [
            _c("flexbox", { staticClass: "file-upload__header" }, [
              _c("div", { staticClass: "title" }, [_vm._v("附件上传")]),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c("el-button", {
                    staticClass: "unfold-button",
                    attrs: { icon: _vm.unfoldIcon },
                    on: { click: _vm.unfoldClick },
                  }),
                  _vm._v(" "),
                  _c("el-button", {
                    staticClass: "close-button",
                    attrs: { icon: "el-icon-close" },
                    on: { click: _vm.close },
                  }),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isUnfold,
                    expression: "isUnfold",
                  },
                ],
                staticClass: "file-upload__body",
              },
              _vm._l(_vm.uploadList, function (item, index) {
                return _c("wk-upload-cell", {
                  key: index,
                  attrs: {
                    index: index,
                    file: item.file,
                    request: item.request,
                    params: item.params,
                    complete: item.complete,
                  },
                  on: {
                    completed: _vm.uploadCompleted,
                    delete: _vm.uploadDelete,
                    cancelTokenChange: _vm.cancelTokenChange,
                  },
                })
              }),
              1
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }